// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyCUdwz1v5XJuwVl0gk3TMgBpSE4FoKP4R0",
  authDomain: "amordebia-1d39a.firebaseapp.com",
  projectId: "amordebia-1d39a",
  storageBucket: "amordebia-1d39a.appspot.com",
  messagingSenderId: "355136666940",
  appId: "1:355136666940:web:cd6dbcaa86c0938fdbb239",
  measurementId: "G-16XK23RDSH",
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
// eslint-disable-next-line no-unused-vars
const analytics = getAnalytics(app);
